import Swiper from "swiper";
import { Autoplay } from "swiper/modules";

const selectors = {
  swiper: "[data-footer-scroller]",
  swiperSlide: "[data-footer-scroller-slide]",
};

const initFooterScroller = (scroller) => {
  const slides = scroller.querySelectorAll(selectors.swiperSlide);

  if (slides.length) {
    const slidesWidth = slides.length * slides[0].getBoundingClientRect().width;
    let duplicateCount = Math.ceil(window.innerWidth / slidesWidth);

    while (duplicateCount > 0) {
      duplicateCount -= 1;
      slides.forEach((slide) => scroller.firstElementChild.append(slide.cloneNode(true)));
    }
  }

  const swiper = new Swiper(scroller, {
    modules: [Autoplay],

    slidesPerView: "auto",
    spaceBetween: 48,
    loop: true,

    speed: 8000,

    autoplay: {
      delay: 0,
    },
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const logoScrollers = document.querySelectorAll(selectors.swiper);

    logoScrollers?.forEach(initFooterScroller);
  },
  {
    once: true,
  }
);
